import { useContext } from "react";
import RbsContext from "src/utils/RoleBasedSecurity/RbsContext";
import { useCompanyId } from "src/Pages/Company/CompanyContext";

const useBasePath = () => {
  const rbsContext = useContext(RbsContext);
  const isAhr = rbsContext.userInfo.isAhr();
  const companyId = useCompanyId();

  if (isAhr) return "/ahr";

  return `/company/edit/${companyId}`;
};

export default useBasePath;
